import React from 'react';
import { removeGoogleAnalytics } from '../helpers/loadScripts';

const Footer = ({ cookieConsent, setCookieConsent }) => {
  const styles = {
    footer: {
      width: "100%",
      backgroundColor: "#32bc9b",
      color: "#fff",
      textAlign: "center",
      padding: "10px",
      position: "fixed",
      bottom: 0,
      fontSize: "14px",
    },
    cookieReset: {
      color: "#32bc9b",
      border: "none",
      borderRadius: "5px",
      position: "absolute",
      right: "30px",
      bottom: "30px",
    },
    spacer: {
      height: "70px",
    }
  };

  return (
    <>
    <footer style={styles.footer}>
        <p>© 2025 WriteWordStudio All rights reserved.</p>
        <p><a href="https://childish-scarecrow-4b8.notion.site/Write-Word-Studio-17e45e4adc7580c4a7a3df6c9bb1f99d">WriteWordStudio サービスページ</a></p>
        <button style={styles.cookieReset} onClick={() => {
        localStorage.removeItem("cookieConsent");
        removeGoogleAnalytics();
        setCookieConsent("");
        }}>Cookieの再設定</button>
    </footer>
      <div style={styles.spacer}></div>
    </>
  );
};

export default Footer;
